import Messages  from "../components/Messages";
import React from "react";
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import { Comment} from 'semantic-ui-react';
import styled from 'styled-components';
import Loading from "../components/Loading";

const DateTime=styled.span`
    opacity:0.6;
    font-size:10px;
    margin-left:10px;
`;
const Me=styled.span`
    color:red;
`;
const newChannelMessageSubscription = gql`
  subscription($channelId: Int!) {
    newChannelMessage(channelId: $channelId) {
      id
      text
      user {
        username
      }
      createdAt
    }
  }
`;
class Messenger extends React.Component {

    componentWillMount(){
        this.unsubscribe=this.subscribe(this.props.channelId);
    }
    componentDidUpdate({channelId}){
        if(this.props.channelId!==channelId){

            if(this.unsubscribe){
                console.log("unsubscribe");
                this.unsubscribe();
            }
            this.unsubscribe=this.subscribe(this.props.channelId);
        }
    }
    componentWillUnmount(){
        if(this.unsubscribe){
            this.unsubscribe();
        }
    }
    subscribe=(channelId)=>
        this.props.data.subscribeToMore({
            document: newChannelMessageSubscription,
            variables: {
                channelId,
            },
            updateQuery: (prev, { subscriptionData }) => {
                if (!subscriptionData) {
                return prev;
                }
                return {
                ...prev,
                messages: [...prev.messages, subscriptionData.data.newChannelMessage],
                };
            },
        });
 

    render() {
        const {data:{loading,messages},username} = this.props;

        return (loading? <Loading/>: 
            <Messages>
                <Comment.Group>
                    {messages.map(m=>{
                        let tm=(new Date(parseInt(m.createdAt,10))).toLocaleTimeString()+' '+ (new Date(parseInt(m.createdAt,10))).toLocaleDateString();
                        
                        return(
                            <Comment key={`${m.id}-message`}>
                                <Comment.Content>
                                    <span>
                                        <b>{(m.user.username)==username?(<Me>You</Me>):m.user.username}</b>
                                        <DateTime>{tm}</DateTime>
                                    </span>
                                    
                                    <Comment.Text>
                                        {m.text}
                                    </Comment.Text>
                                </Comment.Content>
                            </Comment>
                        );
                    })}
                </Comment.Group>
            </Messages>
        
        );
    }
}

const messagesQuery=gql`
   query($channelId:Int!){
       messages(channelId:$channelId){
           id
           text
           user{
               username
           }
           createdAt
       }
   } 
`;

export default graphql(messagesQuery,{
    variables:props => ({
        channelId:props.channelId,
    }),
    options:{
        fetchPolicy:'network-only',
    },
})(Messenger);

